import axios from "axios";
import { setMarketPlaceOrderList, setCarrefourOrderList,setMarketPlaceSplitOrderList, getMarketPlaceOrderDetail, getMarketPlaceSplitOrderDetail, getCheckData,getStatusCount, getDashboardCount,getDashboardSummary,marketPlaceImportOrders,awbGenerateFile,getCarrefourOrderDetail } from "../../../Redux/marketplace/marketplaceSlice";
import UserAuthKey from "../../../components/Common/UserAuthKey";
import { setUserData } from "../../../Redux/user/userSlice";
const apiUrl = process.env.REACT_APP_OMS_API;
const REACT_APP_OMS_API_1= process.env.REACT_APP_OMS_API_1;

export const fetchMarketPlaceOrders = async({ params, dispatch }) => {
  const bearerToken = UserAuthKey();
  const config = {
    method: 'POST',
    url: `${apiUrl}v1/marketplace-orders/marketplaceorder-list`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json',
    },
    data: {
      ...params,
    },
  };
  try {
    const response = await axios(config);
    dispatch(setMarketPlaceOrderList(response?.data));
  } catch (error) {
    if(error?.response?.status === 401){
      dispatch(setUserData(null))
      window.location.replace('/logout');
   }
   else{

   }
  }
  
};
export const fetchCarrefourOrders = async({ params, dispatch }) => {
  const bearerToken = UserAuthKey();
  const config = {
    method: 'POST',
    url: `${apiUrl}v1/marketplace-orders/carrefour-order-list`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json',
    },
    data: {
      ...params,
    },
  };
  try {
    const response = await axios(config);
    dispatch(setCarrefourOrderList(response?.data));
  } catch (error) {
    if(error?.response?.status === 401){
      dispatch(setUserData(null))
      window.location.replace('/logout');
   }
   else{

   }
  }
  
};
export const fetchMarketPlaceSplitOrders = async({ params, dispatch }) => {
  const bearerToken = UserAuthKey();
  const config = {
    method: 'POST',
    url: `${apiUrl}v1/marketplace-orders/marketplaceorder-split-list`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json',
    },
    data: {
      ...params,
    },
  };
  try {
    const response = await axios(config);
    dispatch(setMarketPlaceSplitOrderList(response?.data));
  } catch (error) {
    if(error?.response?.status === 401){
      dispatch(setUserData(null))
      window.location.replace('/logout');
   }
   else{

   }
  }
  
};
export const fetchSTOrders = async ({ params, dispatch }) => {
  const bearerToken = UserAuthKey();
  const config = {
    method: 'POST',
    url: `${apiUrl}v1/marketplace-orders/marketplaceorder-split-list`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json',
    },
    data: {
      ...params,
      is_split: 3,
    },
  };
  try {
    const response = await axios(config);
    dispatch(setMarketPlaceSplitOrderList(response?.data));
  } catch (error) {
    if (error?.response?.status === 401) {
      dispatch(setUserData(null));
      window.location.replace('/logout');
    }
  }
};

export const marketPlaceOrderDetail = async({ params, dispatch }) => {
  const bearerToken = UserAuthKey();
  const config = {
    method: 'POST',
    url: `${apiUrl}v1/marketplace-orders/marketplaceorder-details`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json',
    },
    data: {
      ...params,
    },
  };
  try {
    const response = await axios(config);
    dispatch(getMarketPlaceOrderDetail(response?.data));
  } catch (error) {
    if(error?.response?.status === 401){
      dispatch(setUserData(null))
      window.location.replace('/logout');
   }
   else{

   }
  }
    
  };
  export const marketPlaceSplitOrderDetail = async({ params, dispatch }) => {
    const bearerToken = UserAuthKey();
    const config = {
      method: 'POST',
      url: `${apiUrl}v1/marketplace-orders/marketplacesplitorder-details`,
      headers: {
        Authorization: `Bearer ${bearerToken}`,
        'Content-Type': 'application/json',
      },
      data: {
        ...params,
      },
    };
    try {
      const response = await axios(config);
      dispatch(getMarketPlaceSplitOrderDetail(response?.data));
    } catch (error) {
      if(error?.response?.status === 401){
        dispatch(setUserData(null))
        window.location.replace('/logout');
     }
     else{
  
     }
    }
      
    };
      export const carrefourOrderDetail = async({ params, dispatch }) => {
    const bearerToken = UserAuthKey();
    const config = {
      method: 'POST',
      url: `${apiUrl}v1/marketplace-orders/carrefour-order-details`,
      headers: {
        Authorization: `Bearer ${bearerToken}`,
        'Content-Type': 'application/json',
      },
      data: {
        ...params,
      },
    };
    try {
      const response = await axios(config);
      dispatch(getCarrefourOrderDetail(response?.data));
    } catch (error) {
      if(error?.response?.status === 401){
        dispatch(setUserData(null))
        window.location.replace('/logout');
     }
     else{
  
     }
    }
      
    };
  export const fetchCheckData = async({ formData, dispatch }) => {
    const bearerToken = UserAuthKey();
    const config = {
       method: 'POST',
       url: `${apiUrl}v1/marketplace-orders/marketplaceorder-checkData`,
       headers: {
        Authorization: `Bearer ${bearerToken}`,
       'Content-Type': "multipart/form-data",
      
        },
       
        data: formData, 
      
      };
    try {
       const response = await axios(config);
       dispatch(getCheckData(response?.data));
       } catch (error) {
        if(error?.response?.status === 401){
          dispatch(setUserData(null))
          window.location.replace('/logout');
       }
       else{
    
       }
      }
    // return axios
    // .post(`${apiUrl}v1/marketplace-orders/marketplaceorder-checkData`,formData,  {
    //   headers: {
    //     "Content-Type": "multipart/form-data",
    //   },
    // })
    // .then((response) => {
    //   dispatch(getCheckData(response?.data));
    // })
    // .catch((error) => {
    //   throw error;
    // });
      
  };
  export const fetchMarketplaceCount = async({ params, dispatch }) => {
    const bearerToken = UserAuthKey();
    const config = {
      method: 'POST',
      url: `${apiUrl}v1/marketplace-orders/marketplacestatus-counts`,
      headers: {
        Authorization: `Bearer ${bearerToken}`,
        'Content-Type': 'application/json',
      },
      data: {
        ...params,
      },
    };
    try {
      const response = await axios(config);
      dispatch(getStatusCount(response?.data));
    } catch (error) {
      if(error?.response?.status === 401){
        dispatch(setUserData(null))
        window.location.replace('/logout');
     }
     else{
  
     }
    }
 
  };

  export const fetchMarketDashboardCount = async({ params, dispatch }) => {
    const bearerToken = UserAuthKey();
    const config = {
      method: 'POST',
      url: `${apiUrl}v1/marketplace-orders/marketplaceorder-dashboardcounts`,
      headers: {
        Authorization: `Bearer ${bearerToken}`,
        'Content-Type': 'application/json',
      },
      data: {
        ...params,
      },
    };
    try {
      const response = await axios(config);
      dispatch(getDashboardCount(response?.data));

    } catch (error) {
      if(error?.response?.status === 401){
        dispatch(setUserData(null))
        window.location.replace('/logout');
     }
     else{
  
     }
    }
  
  };
  export const fetchMarketDashboardSummary = async({ params, dispatch }) => {
    const bearerToken = UserAuthKey();
    const config = {
      method: 'POST',
      url: `${apiUrl}v1/marketplace-orders/marketplaceorder-dashboardsummary`,
      headers: {
        Authorization: `Bearer ${bearerToken}`,
        'Content-Type': 'application/json',
      },
      data: {
        ...params,
      },
    };
    try {
      const response = await axios(config);
      dispatch(getDashboardSummary(response?.data));

    } catch (error) {
      if(error?.response?.status === 401){
        dispatch(setUserData(null))
        window.location.replace('/logout');
     }
     else{
  
     }
    }
    
  };
  export const marketPlaceImportSummary = async({ params, dispatch }) => {
    const bearerToken = UserAuthKey();
    const config = {
      method: 'POST',
      url: `${apiUrl}v1/marketplace-orders/marketplaceorder-importData`,
      headers: {
        Authorization: `Bearer ${bearerToken}`,
        'Content-Type': 'application/json',
      },
      data: {
        ...params,
      },
    };
    try {
      const response = await axios(config);
      dispatch(marketPlaceImportOrders(response?.data));

    } catch (error) {
      if(error?.response?.status === 401){
        dispatch(setUserData(null))
        window.location.replace('/logout');
     }
     else{
  
     }
    }
  
  };
  export const fetchInstalCheckData = async({ formData, dispatch }) => {
    const bearerToken = UserAuthKey();
    const config = {
       method: 'POST',
       url: `${apiUrl}v1/marketplace-orders/installation-checkData`,
       headers: {
        Authorization: `Bearer ${bearerToken}`,
       'Content-Type': "multipart/form-data",
      
        },
       
        data: formData, 
      
      };
    try {
       const response = await axios(config);
       dispatch(getCheckData(response?.data));
       } catch (error) {
        if(error?.response?.status === 401){
          dispatch(setUserData(null))
          window.location.replace('/logout');
       }
       else{
    
       }
      }
    // return axios
    // .post(`${apiUrl}v1/marketplace-orders/marketplaceorder-checkData`,formData,  {
    //   headers: {
    //     "Content-Type": "multipart/form-data",
    //   },
    // })
    // .then((response) => {
    //   dispatch(getCheckData(response?.data));
    // })
    // .catch((error) => {
    //   throw error;
    // });
      
  };

  export const installationImportSummary = async({ params, dispatch }) => {
    const bearerToken = UserAuthKey();
    const config = {
      method: 'POST',
      url: `${apiUrl}v1/marketplace-orders/installation-importData`,
      headers: {
        Authorization: `Bearer ${bearerToken}`,
        'Content-Type': 'application/json',
      },
      data: {
        ...params,
      },
    };
    try {
      const response = await axios(config);
      dispatch(marketPlaceImportOrders(response?.data));

    } catch (error) {
      if(error?.response?.status === 401){
        dispatch(setUserData(null))
        window.location.replace('/logout');
     }
     else{
  
     }
    }
  
  };
  export const fetchReturnCheckData = async({ formData, dispatch }) => {
    const bearerToken = UserAuthKey();
    const config = {
       method: 'POST',
       url: `${apiUrl}v1/orders/import-return`,
       headers: {
        Authorization: `Bearer ${bearerToken}`,
       'Content-Type': "multipart/form-data",
      
        },
       
        data: formData, 
      
      };
    try {
       const response = await axios(config);
       dispatch(getCheckData(response?.data));
       } catch (error) {
        if(error?.response?.status === 401){
          dispatch(setUserData(null))
          window.location.replace('/logout');
       }
       else{
    
       }
      }

      
  };


  export const returnImportSummary = async({ params, dispatch }) => {
    const bearerToken = UserAuthKey();
    const config = {
      method: 'POST',
      url: `${apiUrl}v1/orders/insert-import-return`,
      headers: {
        Authorization: `Bearer ${bearerToken}`,
        'Content-Type': 'application/json',
      },
      data: {
        ...params,
      },
    };
    try {
      const response = await axios(config);
      dispatch(marketPlaceImportOrders(response?.data));

    } catch (error) {
      if(error?.response?.status === 401){
        dispatch(setUserData(null))
        window.location.replace('/logout');
     }
     else{
  
     }
    }
  
  };
   export const awbGenerate = async ({ params, dispatch }) => {
  const bearerToken = UserAuthKey();
  const config = {
    method: 'GET',
    url: `${REACT_APP_OMS_API_1}single-awb/dffdf`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json',
    },
    data: {
      ...params,
    },
  };
  try {
    const response = await axios(config);

    dispatch(awbGenerateFile(response?.data));
    
  } catch (error) {
    if (error?.response?.status === 401) {
      dispatch(setUserData(null));
      window.location.replace('/logout');
    } else {
    }
  }
};

/**
 * Bulk generate Amazon AWB for a list of reference numbers and download
 * the merged PDF. Returns { success, message } so the caller can toast.
 */
export const bulkAwbGenerate = async ({ referenceNos }) => {
  const bearerToken = UserAuthKey();
  try {
    const response = await axios({
      method: 'POST',
      url: `${apiUrl}v1/marketplace-orders/bulk-awb`,
      headers: {
        Authorization: `Bearer ${bearerToken}`,
        'Content-Type': 'application/json',
      },
      data: { referenceNos },
      responseType: 'blob',
    });

    // If the backend returned JSON (an error), it still arrives as a blob.
    const contentType = response?.headers?.['content-type'] || '';
    if (contentType.includes('application/json')) {
      const text = await response.data.text();
      const json = JSON.parse(text || '{}');
      return { success: false, message: json?.message || 'Failed to generate AWB' };
    }

    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `bulk_awb_${Date.now()}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return { success: true, message: 'AWB downloaded successfully' };
  } catch (error) {
    if (error?.response?.status === 401) {
      window.location.replace('/logout');
      return { success: false, message: 'Session expired' };
    }
    // Error responses also come back as a blob because of responseType.
    let message = 'Failed to generate AWB';
    try {
      if (error?.response?.data) {
        const text = await error.response.data.text();
        const json = JSON.parse(text || '{}');
        message = json?.message || message;
      }
    } catch (e) {
      // keep default message
    }
    return { success: false, message };
  }
};